const Inputs = (
{
  brands,
  setSelectedBrand, 
  mortarGap,
  setMortarGap,
  selectedBrick,
  setSelectBrick,
  onlyStandardBricks,
  database,
  wallDimensions,
  isMobile,
  setWallDimensions,
  brickStats,

  plasterEnabled,
  setPlasterEnabled,
  plasterBothSides,
  setPlasterBothSides,
  plasterThickness,
  setPlasterThickness,

  paintEnabled,
  setPaintEnabled,
  paintBothSides,
  setPaintBothSides,
  paintCoats,
  setPaintCoats
}) => 
{
  const handleDimensionChange = (e) => 
  {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;
    const roundedValue = Math.max(0.05, Math.round(numericValue * 20) / 20);
    setWallDimensions(prev => ({
      ...prev,
      [name]: roundedValue
    }));
  };

   const handleMortarGapChange = (e) =>
  {
    const value = parseFloat(e.target.value) || 0;
    // Redondear al múltiplo de 0.5 más cercano
    const roundedValue = Math.round(value * 2) / 2;
    // Asegurar que esté entre 0.5 y 5 cm
    const clampedValue = Math.max(0, Math.min(5, roundedValue));
    setMortarGap(clampedValue);
  };

  const handlePlasterThicknessChange = (e) => 
  {
    const value = parseFloat(e.target.value) || 0;
    const clampedValue = Math.max(1, Math.min(3, value));
    setPlasterThickness(clampedValue);
  };

  const handlePaintCoatsChange = (e) =>
  {
    const value = parseInt(e.target.value) || 1;
    const clampedValue = Math.max(1, Math.min(5, value));
    setPaintCoats(clampedValue);
  };

  if(!database) return null; 

  return (
    <div className = "flex flex-col p-4 bg-gray-200 overflow-y-auto z-50 sm:w-3/12 sm:min-w-[300px] sm:h-full h-1/2">          

      <h2 className = "text-xl font-semibold mb-4 text-center uppercase">Parámetros de la Pared</h2>

      <div className="space-y-4">
            
        {['length', 'height'].map((dim) => (
          <div key={dim}>
            <label className="block text-sm font-medium text-gray-700">
              {dim === 'length' ? `Longitud${ isMobile ? ` - ${wallDimensions[dim]}` : ''}` : `Altura${ isMobile ? ` - ${wallDimensions[dim]}` : ''}`} (m)
            </label>
            
            <input
              type = { isMobile ? "range" : "number"}
              inputMode ="decimal"
              pattern = "[0-9]*"
              name = {dim}
              value = {wallDimensions[dim]}
              onChange = {(e) => handleDimensionChange(e)}
              className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
              min = "1"
              max = { dim === 'length' ? isMobile ? 10 : 20 : isMobile ? 5 : 10 }
              step = "0.05"
            />
            
            <p className="text-xs text-gray-500">{`Incrementos de 5 cm (mínimo 1 metro - máximo ${dim === 'length' ? isMobile ? 10 : 20 : isMobile ? 5 : 10}) metros`}</p>
          </div>
        ))}

        <div>
          <label className="block text-sm font-medium text-gray-700">
            {`Espesor de mortero${ isMobile ? ` - ${mortarGap}` : ''} (cm)`}
          </label>

          <input
            type = { isMobile ? "range" : "number"}
            inputMode = "decimal"
            pattern = "[0-9]*"
            value = {mortarGap}
            onChange = {handleMortarGapChange}
            className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
            min = "0"
            max = "5"
            step = "0.5"
          />
          
          <p className="text-xs text-gray-500">Incrementos de 0.5 cm (mínimo 1 cm, máximo 5 cm)</p>
        </div>

      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 pt-3">Seleccionar Marca De Ladrillos</label>
        <select
          className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border uppercase"
          value = {selectedBrick.id}
          onChange = {(e) => setSelectedBrand(e.target.value)}
        >
          {Object.keys(brands).map(brand => (
            <option key = {brand} value={brand} className = "uppercase">{brand}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 pt-3">Seleccionar Ladrillo</label>
        <select
          className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
          value = {selectedBrick.id}
          onChange = {(e) => setSelectBrick(database.find(b => b.id === e.target.value))}
        >
          {onlyStandardBricks.map(block => (
            <option key = {block.id} value={block.id}>{block.brand} - {block.name}</option>
          ))}
        </select>
      </div>

       <div className="border-t border-gray-400 pt-2 mt-4">
        <div className="flex items-center">
          <input
            type = "checkbox"
            id = "plasterEnabled"
            checked = {plasterEnabled}
            onChange = {(e) => setPlasterEnabled(e.target.checked)}
            className = "mr-2"
          />
          <label htmlFor = "plasterEnabled" className="text-sm font-medium text-gray-700">Aplicar enlucido</label>
        </div>

        {plasterEnabled && (
          <div className="ml-6 mt-2 space-y-2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Espesor del enlucido (cm)
              </label>
              <input
                type = "number"
                inputMode = "decimal"
                value = {plasterThickness}
                onChange = {handlePlasterThicknessChange}
                className = "mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                min = "1"
                max = "3"
                step = "0.5"
              />
              <p className="text-xs text-gray-500">Entre 1 cm y 3 cm</p>
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="plasterBothSides"
                checked={plasterBothSides}
                onChange={(e) => setPlasterBothSides(e.target.checked)}
                className="mr-2"
              />
              <label htmlFor="plasterBothSides" className="text-sm font-medium text-gray-700">Enlucir ambas caras</label>
            </div>
          </div>
        )}
      </div>

      <div className="border-t border-gray-400 pt-2 mt-4">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="paintEnabled"
            checked={paintEnabled}
            onChange={(e) => setPaintEnabled(e.target.checked)}
            className="mr-2"
          />
          <label htmlFor="paintEnabled" className="text-sm font-medium text-gray-700">Aplicar pintura</label>
        </div>

        {paintEnabled && (
          <div className="ml-6 mt-2 space-y-2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Número de manos
              </label>
              <input
                type="number"
                value={paintCoats}
                onChange={handlePaintCoatsChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                min="1"
                max="5"
              />
              <p className="text-xs text-gray-500">Entre 1 y 5 manos</p>
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="paintBothSides"
                checked={paintBothSides}
                onChange={(e) => setPaintBothSides(e.target.checked)}
                className="mr-2"
              />
              <label htmlFor="paintBothSides" className="text-sm font-medium text-gray-700">Pintar ambas caras</label>
            </div>
          </div>
        )}
      </div>






      <h3 className = "text-xl font-semibold font-mono mt-3 mb-1 text-center uppercase">Resultados</h3>

      <h4 className = "text-base font-semibold font-mono my-1 text-center uppercase">cantidades</h4>

      <div className="flex justify-between mb-2">
        <span>Área de la Pared:</span>
        <span className="font-bold">{Math.round(wallDimensions.length * wallDimensions.height * 100) / 100} m²</span>
      </div>

      <div className="flex justify-between mb-2">
        <span>Volumen total de mortero:</span>
        <span className="font-bold">{brickStats.totalMortarVolume} m³</span>
      </div>

      {brickStats.plasterVolume > 0 &&
        <div className="flex justify-between mb-2">
          <span>Volumen total de enlucido:</span>
          <span className="font-bold">{brickStats.plasterVolume} m³</span>
        </div>
      }
      
      <div className="flex justify-between mb-2">
        <span>Ladrillos completos:</span>
        <span className="font-bold">{brickStats.brickCounts.fullBricks}</span>
      </div>
      
      <div className="flex justify-between mb-2">
        <span>Medios ladrillos completos:</span>
        <span className="font-bold">{brickStats.brickCounts.halfBricks}</span>
      </div>
      
      <div className="mt-4">
        <h5 className="font-bold mb-2">Ladrillos incompletos:</h5>
        {brickStats.brickCounts.customBricks.map((group, index) => (
          <div key={index} className="mb-3 p-3 bg-white rounded shadow-sm">
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span>Cantidad:</span>
                <span className="font-bold">{group.count}</span>
              </div>
              <div className="flex justify-between">
                <span>Dimensiones:</span>
                <span className="font-bold">{group.dimensions.thickness} × {group.dimensions.height} × {group.dimensions.length} cm</span>
              </div>
              <div className="flex justify-between">
                <span>Tipo:</span>
                <span className="font-bold">{group.dimensions.type}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h4 className = "text-base font-semibold font-mono my-1 text-center uppercase">cargas</h4>

      <div className="flex justify-between mb-2">
        <span>Peso Total:</span>
        <span className="font-bold">{brickStats.totalWeight} Kg</span>
      </div>

      <div className="flex justify-between mb-2">
        <span>Carga Lineal:</span>
        <span className="font-bold">{brickStats.linearWeight} Kg/m</span>
      </div>

      <h4 className = "text-base font-semibold font-mono my-1 text-center uppercase">costos</h4>

      <div className="flex justify-between mb-2">
        <span>Costo Mortero:</span>
        <span className="font-bold">{brickStats.mortarCost} $</span>
      </div>

      <div className="flex justify-between mb-2">
        <span>Costo Ladrillo:</span>
        <span className="font-bold">{brickStats.bricksCost} $</span>
      </div>

      <div className="flex justify-between mb-2">
        <span>Costo Total Materiales:</span>
        <span className="font-bold">{Math.round((brickStats.mortarCost + brickStats.bricksCost) * 100) / 100} $</span>
      </div>

    </div>
  )
};

export default Inputs;